import * as React from 'react';

import { compose, withProps } from 'recompose';

import { getCmsLocaleString } from 'js/lib/language';

import CampaignModulesDataProviderForCPlusLanding from 'bundles/campaigns/providers/CampaignModulesDataProviderForCPlusLanding';
import LandingPageContentful from 'bundles/coursera-plus-landing-page/components/LandingPageContentful';
import { HIDDEN_SLUG_FOR_DEFAULT_LANDING_PAGE } from 'bundles/coursera-plus-landing-page/contentful/constants';
import { withLandingPageData } from 'bundles/coursera-plus-landing-page/contentful/fetchContentful';
import type {
  PropsForLandingPageQuery,
  PropsFromLandingPage,
} from 'bundles/coursera-plus-landing-page/contentful/fetchContentful';
import NotFound from 'bundles/phoenix/components/NotFound';

type PropsFromCaller = {};
type PropsToComponent = PropsForLandingPageQuery & PropsFromLandingPage;

export const LandingPage = (props: PropsToComponent) => {
  if (!props.landingPage) {
    return <NotFound />;
  }

  return (
    <CampaignModulesDataProviderForCPlusLanding>
      <LandingPageContentful landingPage={props.landingPage} hideRegionalPromotionBanner={false} />
    </CampaignModulesDataProviderForCPlusLanding>
  );
};

export default compose<PropsToComponent, PropsFromCaller>(
  withProps(() => {
    const propsForQuery = {
      slug: HIDDEN_SLUG_FOR_DEFAULT_LANDING_PAGE,
      preview: false,
      locale: getCmsLocaleString(),
    };
    return propsForQuery;
  }),
  withLandingPageData()
)(LandingPage);
